import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import GameDashboard from '../components/GameDashboard'
import BorgWarnerBackground from '../components/BorgWarnerBackground'

export default function DashboardPage() {
  const { user, loading } = useAuth()
  const navigate = useNavigate()

  if (loading) return null
  if (!user) { navigate('/login'); return null }

  return (
    <div className="app" style={{ minHeight: '100vh', position: 'relative', overflow: 'hidden' }}>
      <BorgWarnerBackground />
      <header className="app-header" style={{ position: 'relative', zIndex: 1 }}>
        <div className="header-logo">🏎️</div>
        <div className="header-title">
          <h1>Race Day Pool</h1>
          <p>Indianapolis Motor Speedway · May 24, 2026</p>
        </div>
        <nav className="header-nav">
          <button className="nav-btn active">🎮 My Games</button>
        </nav>
      </header>
      <main className="app-main" style={{ position: 'relative', zIndex: 1 }}>
        <GameDashboard
          onOpenGame={slug => navigate(`/game/${slug}`)}
          onNewGame={() => {}}
        />
      </main>
    </div>
  )
}
